import { http } from '../../config/axios'

export default function getClienteDocumentoDownload(id: string): Promise<any> {
  return http
    .get(`api/client/documento/download/${id}`)
    .then((res) => res.data)
    .catch((error) => {
      console.error('Erro getClienteDocumentoDownload', error)
      throw Error(error.response?.data || 'Erro ao baixar documento')
    })
}
